import {
  QueryClient,
  QueryClientProvider as TanStackQueryClientProvider,
} from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime in v4)
      retry(failureCount, error) {
        // Don't retry auth errors
        if (
          error instanceof Error &&
          (error.message === 'Authentication not ready' ||
            error.message === 'No access token available')
        ) {
          return false;
        }

        return failureCount < 3;
      },
    },
  },
});

function QueryClientProvider({children}: React.PropsWithChildren) {
  return <TanStackQueryClientProvider client={queryClient}>{children}</TanStackQueryClientProvider>;
}

export {queryClient, QueryClientProvider};
